import { Component } from '@angular/core';

@Component({
    selector: 'app-kids-course',
    templateUrl: './kids-course.component.html',
    standalone: false
})
export class KidsCourseComponent {
}
